module.exports = __webpack_public_path__ + "img/Veterinärzug.62f41335.svg";